// src/pages/projects/Hotel.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './ProjectDetail.module.css';

import hotel1 from '../../assets/hotel1.png';
import hotel2 from '../../assets/hotel2.png';
import hotel3 from '../../assets/hotel3.png';
import hotel4 from '../../assets/hotel4.png';
import hotel5 from '../../assets/hotel5.png';
import hotel6 from '../../assets/hotel6.png';
import hotel7 from '../../assets/hotel7.png';
import hotel8 from '../../assets/hotel8.png';
import hotel9 from '../../assets/hotel9.png';
import hotel10 from '../../assets/hotel10.png';
import hotel11 from '../../assets/hotel11.png';
import hotel12 from '../../assets/hotel12.png';
import hotel13 from '../../assets/hotel13.png';
import hotel14 from '../../assets/hotel14.png';
import hotel15 from '../../assets/hotel15.png';

const images = [
  hotel1, hotel2, hotel3, hotel4, hotel5,
  hotel6, hotel7, hotel8, hotel9, hotel10,
  hotel11, hotel12, hotel13, hotel14, hotel15
];

export default function Hotel() {
  const [current, setCurrent] = useState(0);

  const nextImage = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Hotel Management System</h1>

      <div className={styles.carousel}>
        <button onClick={prevImage} className={styles.navBtn}>❮</button>
        <img
          src={images[current]}
          alt={`Hotel Screenshot ${current + 1}`}
          className={`${styles.carouselImage} ${styles.fadeIn}`}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <button onClick={nextImage} className={styles.navBtn}>❯</button>
      </div>

      <p className={styles.description}>
        The <strong>Hotel Management System</strong> is a full-stack web project developed using <strong>HTML, CSS, JavaScript, PHP, and MySQL</strong>. This project was designed to streamline hotel operations such as reservations, guest management, and room tracking.
      </p>

      <p className={styles.description}>
        <strong>Admin Panel Features:</strong><br />
        • Secure admin login system<br />
        • <strong>Manage rooms</strong> — add, edit, or delete room details<br />
        • <strong>Track bookings</strong> and customer details<br />
        • <strong>Generate reports</strong> for occupancy and transactions<br />
        • <strong>Manage user roles</strong> and access
      </p>

      <p className={styles.description}>
        <strong>User Features:</strong><br />
        • Search for available rooms<br />
        • Book rooms online<br />
        • Receive booking confirmation<br />
        • View hotel services and details easily
      </p>

      <ul className={styles.features}>
        <li>✅ Full CRUD operations for rooms and bookings</li>
        <li>✅ Separate login systems for admin and users</li>
        <li>✅ Responsive frontend using HTML, CSS & JavaScript</li>
        <li>✅ Secure backend with PHP and MySQL</li>
        <li>✅ Real-time room availability and booking management</li>
      </ul>

      <div className={styles.buttonGroup}>
        <Link to="/" className={styles.backBtn}>← Back to Home</Link>
      </div>
    </div>
  );
}
